<template>
  <div class="promotion">
    <div class="left">
      <ul>
        <li
          v-for="(o, index) in menues"
          :key="index"
          @click="switchMenu(index)"
          :class="{ on: currentIndex == index }"
        >{{ o.menuName }}</li>
      </ul>

      <dl v-if="viewMode === 'list' && menues.length > 0">
        <dd
          v-for="(o, index) in promos"
          :key="index"
          v-show="menues[currentIndex] && o.promotype == menues[currentIndex].promotype"
          @click="goPromo(o)"
        >
          <img :src="o.picUrl + '/img/promopics/app/' + o.picPromo" />
          <div>
            <p>{{ o.title }}</p>
            <span>{{ o.startTimeDesc }}</span>
          </div>
        </dd>
      </dl>

      <!-- PG 电游大礼包 -->
      <div class="pg-detail" v-if="viewMode === 'pg'">
        <div class="pg-content"></div>
        <p class="pg-intro">PG 电游热门游戏，深受各位新老客户喜爱，现我司独家推出针对PG游戏大礼包，集合各种投注有奖返利活动，欢迎新老玩家入驻。</p>
        <div class="pg-option">
          <ul>
            <li :class="{ on: pgCurrentIndex == 0 }" @click="pgCurrentIndex = 0">全部</li>
            <li :class="{ on: pgCurrentIndex == 1 }" @click="pgCurrentIndex = 1" v-show="false">注单</li>
            <li :class="{ on: pgCurrentIndex == 2 }" @click="pgCurrentIndex = 2" v-show="false">救援金</li>
          </ul>
          <div @click="$parent.openPromoRecord(0)">领取记录</div>
        </div>
        <div class="pg-record">
          <ul>
            <li v-if="rescueUi" style="background:#008CFF66;" v-show="pgCurrentIndex == 0 || pgCurrentIndex == 2 && rescueUi.promoType == 1">
              <div class="top">
                <p>{{ rescueUi.title }}</p>
                <span @click="$parent.promo1Show = 0">活动详情</span>
              </div>
              <div class="info">
                <div>
                  <p>{{ rescueUi.subTitle }}</p>
                  <p>{{ rescueUi.startTime }}</p>
                </div>
                <span>{{ rescueUi.reward }}</span>
              </div>
              <div class="desc">
                <p><span>统计时间</span><span>{{ rescueUi.reportTime }}</span></p>
                <p><span>净输赢</span><span>{{ rescueUi.totalWinlost }}</span></p>
              </div>
              <div class="btn" @click="applicationPGPromoAsync(rescueUi)" style="background:linear-gradient(180deg, #FFE19C 0%, #FFB200 100%)">{{ rescueUi.buttonStatus == 0 ? '' : '已' }}{{ rescueUi.submitType == 0 ? '领取' : '申请' }}</div>
            </li>
            <li v-if="orderUi" style="background:#FFAB0F66;" v-show="pgCurrentIndex == 0 || pgCurrentIndex == 1 && orderUi.promoType == 0">
              <div class="top">
                <p>{{ orderUi.title }}</p>
                <span @click="$parent.promo1Show = 1">活动详情</span>
              </div>
              <div class="info">
                <div>
                  <p>{{ orderUi.subTitle }}</p>
                  <p>{{ orderUi.startTime }}</p>
                </div>
                <span>{{ orderUi.reward }}</span>
              </div>
              <div class="desc">
                <p><span>统计时间</span><span>{{ orderUi.reportTime }}</span></p>
                <p><span>注单数量</span><span>{{ orderUi.orderCount }}</span></p>
              </div>
              <div class="btn" @click="applicationPGPromoAsync(orderUi)" style="background:linear-gradient(180deg, #FFE19C 0%, #FFB200 100%)">{{ orderUi.buttonStatus == 0 ? '' : '已' }}{{ orderUi.submitType == 0 ? '领取' : '申请' }}</div>
            </li>
            <li v-if="betUi" style="background:#FF585866;" v-show="pgCurrentIndex == 0 || pgCurrentIndex == 1 && betUi.promoType == 0">
              <div class="top">
                <p>{{ betUi.title }}</p>
                <span @click="$parent.promo1Show = 2">活动详情</span>
              </div>
              <div class="info">
                <div>
                  <p>{{ betUi.subTitle }}</p>
                  <p>{{ betUi.startTime }}</p>
                </div>
                <span>{{ betUi.reward }}</span>
              </div>
              <div class="desc">
                <p><span>统计时间</span><span>{{ betUi.reportTime }}</span></p>
                <p><span>流水总额</span><span>{{ betUi.totalBetAmount }}</span></p>
              </div>
              <div class="btn" @click="applicationPGPromoAsync(betUi)" style="background:linear-gradient(180deg, #FFE19C 0%, #FFB200 100%)">{{ betUi.buttonStatus == 0 ? '' : '已' }}{{ betUi.submitType == 0 ? '领取' : '申请' }}</div>
            </li>
            <li v-if="luckyOrderUi" style="background:#FFF64A66;" v-show="pgCurrentIndex == 0 || pgCurrentIndex == 1 && luckyOrderUi.promoType == 0">
              <div class="top">
                <p>{{ luckyOrderUi.title }}</p>
                <span @click="$parent.promo1Show = 3">活动详情</span>
              </div>
              <div class="info">
                <div>
                  <p>{{ luckyOrderUi.subTitle }}</p>
                  <p>{{ luckyOrderUi.startTime }}</p>
                </div>
                <span>{{ luckyOrderUi.reward }}</span>
              </div>
              <div class="desc">
                <p><span>统计时间</span><span>{{ luckyOrderUi.reportTime }}</span></p>
                <p><span>注单编号</span><span>{{ luckyOrderUi.orderNo }}</span></p>
              </div>
              <div class="btn" @click="applicationPGPromoAsync(luckyOrderUi)" style="background:linear-gradient(180deg, #FFE19C 0%, #FFB200 100%)">{{ luckyOrderUi.buttonStatus == 0 ? '' : '已' }}{{ luckyOrderUi.submitType == 0 ? '领取' : '申请' }}</div>
            </li>
            <li v-if="highOddsOrdersUi" style="background:#60FF6566;" v-show="pgCurrentIndex == 0 || pgCurrentIndex == 1 && highOddsOrdersUi.promoType == 0">
              <div class="top">
                <p>{{ highOddsOrdersUi.title }}</p>
                <span @click="$parent.promo1Show = 5">活动详情</span>
              </div>
              <div class="info">
                <div>
                  <p>{{ highOddsOrdersUi.subTitle }}</p>
                  <p>{{ highOddsOrdersUi.startTime }}</p>
                </div>
                <span>{{ highOddsOrdersUi.reward }}</span>
              </div>
              <div class="desc">
                <p><span>统计时间</span><span>{{ highOddsOrdersUi.reportTime }}</span></p>
                <p><span>注单编号</span><span>{{ highOddsOrdersUi.orderNo }}</span></p>
              </div>
              <div class="btn" @click="applicationPGPromoAsync(highOddsOrdersUi)" style="background:linear-gradient(180deg, #FFE19C 0%, #FFB200 100%)">{{ highOddsOrdersUi.buttonStatus == 0 ? '' : '已' }}{{ highOddsOrdersUi.submitType == 0 ? '领取' : '申请' }}</div>
            </li>
            <li v-if="taskLevelUi" style="background:#C164FF66;" v-show="pgCurrentIndex == 0 || pgCurrentIndex == 1 && taskLevelUi.promoType == 0">
              <div class="top">
                <p>{{ taskLevelUi.title }}</p>
                <span @click="$parent.promo1Show = 4">活动详情</span>
              </div>
              <div class="info">
                <div>
                  <p>{{ taskLevelUi.subTitle }}</p>
                  <p>{{ taskLevelUi.startTime }}</p>
                </div>
                <span>{{ taskLevelUi.reward }}</span>
              </div>
              <div class="desc">
                <p><span>累计流水</span><span>{{ taskLevelUi.totalBetAmount }}</span></p>
                <p><span>关卡</span><span>{{ taskLevelUi.taskLevel }}</span></p>
              </div>
              <div class="btn" @click="applicationPGPromoAsync(taskLevelUi)" style="background:linear-gradient(180deg, #FFE19C 0%, #FFB200 100%)">{{ taskLevelUi.buttonStatus == 0 ? '' : '已' }}{{ taskLevelUi.submitType == 0 ? '领取' : '申请' }}</div>
            </li>
          </ul>
        </div>
        <div class="pg-rules">
          <p></p>
          <div>
            1.优惠时间以每日0:00:00-23:59:59为单位，系统会统计会员在每个单位时间的PG和电游平台投注数据，包括注单数据，投注数据等。此数据实时更新，具体请查看注单详情，关于优惠奖金政策请查看具体优惠详情。<br />
            2.部分优惠是系统派发，部分优惠需要审核后派发，具体以单个优惠详情为主。<br />
            3.特定优惠仅针对特定游戏平台，非指定平台不能参加此类单项优惠，具体优惠资格以详情为准，或者咨询客服了解更多优惠资讯.
          </div>
        </div>
      </div>

      <!-- 幸运大转盘 /turntable2 -->
      <turntable-promo v-if="viewMode === 'turntable'" />

      <!-- 周周体育专题 /promoweek -->
      <promo-week-promo v-if="viewMode === 'promoweek'" />

      <!-- EWC 电竞世界杯超级福利秀 /espromo -->
      <es-promo v-if="viewMode === 'es'" />

      <!-- 普通优惠详情：须用 v-if，v-show 在 currentPromo 为 null 时仍会求值导致整页报错 -->
      <div class="promo-detail" v-if="viewMode === 'detail' && currentPromo">
        <div class="detail-banner" v-if="promoBannerUrl">
          <img :src="promoBannerUrl" alt="" />
        </div>
        <div class="detail-body">
          <h2 class="detail-title">{{ currentPromo.title }}</h2>
          <p class="detail-time" v-if="currentPromo.startTimeDesc">开始时间：{{ currentPromo.startTimeDesc }}</p>
          <div class="detail-table-block" v-for="(table, tIndex) in currentPromo.tableList" :key="'t' + tIndex">
            <p class="table-title" v-if="table.tableTitle">{{ formatTableTitle(table.tableTitle) }}</p>
            <div class="table-wrap" v-if="table.tableRowsV && table.tableRowsV.length">
              <table>
                <thead v-if="table.tableRowsV[0]">
                  <tr>
                    <th v-for="(cell, cIndex) in table.tableRowsV[0]" :key="'h' + cIndex">{{ cell }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, rIndex) in table.tableRowsV.slice(1)" :key="'r' + rIndex">
                    <td v-for="(cell, cIndex) in row" :key="'c' + cIndex">{{ cell }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="detail-section" v-if="currentPromo.howApplication">
            <h3>参与方式</h3>
            <p>{{ currentPromo.howApplication }}</p>
          </div>
          <div class="detail-section" v-if="currentPromo.promoRuleList && currentPromo.promoRuleList.length">
            <h3>活动规则</h3>
            <p v-for="(rule, rIndex) in currentPromo.promoRuleList" :key="'rule' + rIndex">{{ rule }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="right">
      <ul class="msg-tabs">
        <li :class="{ on: currentIndexNotice === 0 }" @click="switchNoticeTab(0)">
          <img class="tab-icon" src="@/img/sts5.png" alt="" />
          <span>公告</span>
        </li>
        <li class="tab-site" :class="{ on: currentIndexNotice === 1, 'has-unread': currentIndexNotice !== 1 && messageCount > 0 }" @click="switchNoticeTab(1)">
          <img class="tab-icon" src="@/img/chat1.png" alt="" />
          <span class="tab-label">站内信</span>
          <span class="tab-tag" v-if="isLoggedIn" :class="{ unread: messageCount > 0 }">{{ messageTagText }}</span>
        </li>
      </ul>
      <div class="msg-list">
        <template v-if="currentIndexNotice === 0">
          <div class="msg-item notice" v-for="(o, index) in noticeMessage.list" :key="'n' + index">
            <p class="title" v-if="o.title">{{ o.title }}</p>
            <div class="content">{{ o.body }}</div>
            <span class="time">{{ o.createtime }}</span>
          </div>
          <div class="msg-empty" v-show="noticeMessage.list.length === 0">
            <img src="@/img/nodata.png" />
            <span>暂无记录</span>
          </div>
        </template>
        <template v-if="currentIndexNotice === 1">
          <div class="msg-item" v-for="(o, index) in siteMessage.list" :key="'s' + index">
            <p class="title">{{ o.title }}</p>
            <div class="content">{{ o.content }}</div>
            <span class="time">{{ o.createtime }}</span>
          </div>
          <div class="msg-empty" v-show="siteMessage.list.length === 0">
            <img src="@/img/nodata.png" />
            <span>暂无记录</span>
          </div>
        </template>
      </div>
      <div class="msg-foot" @click="openNoticeAll">
        <span>{{ currentIndexNotice === 0 ? '公告' : '站内信' }}</span>
        <span>· 查看全部</span>
        <span class="arrow"></span>
      </div>
      <div class="app-dl">
        <div class="qr-side">
          <div class="qr-box" id="promo_qrcode"></div>
          <p>APP下载</p>
          <div class="app-btns">
            <span :class="{ on: appPlatform === 'android' }" @click="switchAppQr('android')">安卓</span>
            <span :class="{ on: appPlatform === 'ios' }" @click="switchAppQr('ios')">IOS</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  queryPromosIe,
  queryPromosById,
  queryNotice,
  querySiteChat,
  qeuryMessageCount,
  queryAppData,
  queryPGDailyRescuePromoUI,
  queryPGDailyOrderPromoUI,
  queryPGDailyBetPromoUI,
  applicationPGPromo,
  queryPGLuckyOrderPromoUI_V,
  queryPGTaskLevelPromoUI_V,
  queryPGHighOddsOrdersPromoUI_V
} from '../api';
import { getStore } from '~/config/utils';
import QRCode from 'qrcodejs2';
import TurntablePromo from './TurntablePromo.vue';
import PromoWeekPromo from './PromoWeekPromo.vue';
import EsPromo from './EsPromo.vue';

export default {
  name: 'PromotionPage',
  components: {
    TurntablePromo,
    PromoWeekPromo,
    EsPromo
  },
  data() {
    return {
      promos: [],
      menues: [],
      currentIndex: 0,
      viewMode: 'list',
      currentPromo: null,
      pgCurrentIndex: 0,
      pgLoaded: false,
      rescueUi: null,
      orderUi: null,
      betUi: null,
      luckyOrderUi: null,
      taskLevelUi: null,
      highOddsOrdersUi: null,
      currentIndexNotice: 0,
      noticeMessage: {
        list: []
      },
      siteMessage: {
        list: []
      },
      messageCount: 0,
      appData: {},
      appPlatform: 'android',
      promoQrcode: null
    };
  },
  computed: {
    isLoggedIn() {
      return !!(this.$parent.userData && this.$parent.userData.account);
    },
    messageTagText() {
      if (this.messageCount > 0) {
        return this.messageCount > 99 ? '99+' : String(this.messageCount);
      }
      return '已读';
    },
    promoBannerUrl() {
      if (!this.currentPromo || !this.currentPromo.picUrl) return '';
      const pathData = this.currentPromo.pathData;
      const picPath = pathData && pathData[1] ? pathData[1].picPath : '/img/promopics/app';
      return this.currentPromo.picUrl + picPath + '/' + this.currentPromo.picBanner;
    }
  },
  watch: {
    '$parent.userData.account'() {
      this.initMessageData();
    }
  },
  created() {
    this.viewMode = 'list';
    this.currentPromo = null;
    this.queryPromosIeAsync();
    this.queryNoticeAsync();
    this.initMessageData();
  },
  mounted() {
    this.initAppDownload();
  },
  methods: {
    switchMenu(index) {
      this.currentIndex = index;
      this.viewMode = 'list';
      this.currentPromo = null;
    },
    formatTableTitle(title) {
      if (!title) return '';
      return String(title).replace(/\.\$\$\$|\$\$\$/g, '');
    },
    async queryPromosIeAsync() {
      let result = await queryPromosIe(0);
      if (!result.Message) {
        this.menues = result.Result.promoMenues;
        this.promos = result.Result.promoModels;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    goPromo(promo) {
      const userName = getStore('UserName');
      const token = getStore('Token');

      if (promo.bannerPromoType == 0) {
        if (promo.id == 10027 || promo.id == 10028 || promo.id == 10029 || promo.id == 10038) {
          if (!(userName && token)) {
            return this.$toast.fail('该优惠需要登录后方可查看');
          }
        }
        this.showPromoDetail(promo);
        return;
      }

      if (promo.bannerPromoPath === '/pgpromo') {
        if (!(userName && token)) {
          return this.$toast.fail('该优惠需要登录后方可查看');
        }
        this.showPgPromo();
        return;
      }

      if (promo.bannerPromoPath === '/espromo') {
        this.showEsPromo();
        return;
      }

      if (promo.bannerPromoPath === '/turntable2') {
        if (!(userName && token)) {
          return this.$toast.fail('该优惠需要登录后方可查看');
        }
        this.showTurntablePromo();
        return;
      }

      if (promo.bannerPromoPath === '/promoweek') {
        if (!(userName && token)) {
          return this.$toast.fail('该优惠需要登录后方可查看');
        }
        this.showPromoWeekPromo();
        return;
      }

      if (userName && token) {
        if (promo.id == 10200) {
          this.showPgPromo();
        } else {
          window.open(promo.promoDescPageUrl + '&userName=' + userName + '&token=' + token + '&sign=1');
        }
      } else {
        return this.$toast.fail('该优惠需要登录后方可查看');
      }
    },
    async showPromoDetail(promo) {
      let result = await queryPromosById(promo.id);
      if (result.Message) {
        return this.$toast.fail(result.Message);
      }
      if (!result.Result || !result.Result.length) {
        return this.$toast.fail('优惠详情不存在');
      }
      this.currentPromo = result.Result[0];
      this.viewMode = 'detail';
    },
    showPgPromo() {
      this.viewMode = 'pg';
      this.currentPromo = null;
      if (!this.pgLoaded) {
        this.loadPgPromoData();
        this.pgLoaded = true;
      }
    },
    showTurntablePromo() {
      this.viewMode = 'turntable';
      this.currentPromo = null;
    },
    showPromoWeekPromo() {
      this.viewMode = 'promoweek';
      this.currentPromo = null;
    },
    showEsPromo() {
      this.viewMode = 'es';
      this.currentPromo = null;
    },
    loadPgPromoData() {
      this.queryPGDailyRescuePromoUIAsync();
      this.queryPGDailyOrderPromoUIAsync();
      this.queryPGDailyBetPromoUIAsync();
      this.queryPGLuckyOrderPromoUI_VAsync();
      this.queryPGTaskLevelPromoUI_VAsync();
      this.queryPGHighOddsOrdersPromoUI_VAsync();
    },
    pickPromoCode(ui) {
      if (!ui) return null;
      const v = ui.promoCode != null ? ui.promoCode : ui.PromoCode;
      return v != null && v !== '' ? Number(v) : null;
    },
    async applicationPGPromoAsync(ui) {
      const promoCode = this.pickPromoCode(ui);
      if (promoCode == null || Number.isNaN(promoCode)) {
        this.$toast.fail('优惠编号无效');
        return;
      }
      let result = await applicationPGPromo(promoCode);
      if (!result.Message) {
        this.$toast.success('操作成功');
        this.loadPgPromoData();
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async queryPGDailyRescuePromoUIAsync() {
      let result = await queryPGDailyRescuePromoUI();
      if (result.Result) this.rescueUi = result.Result;
    },
    async queryPGDailyOrderPromoUIAsync() {
      let result = await queryPGDailyOrderPromoUI();
      if (result.Result) this.orderUi = result.Result;
    },
    async queryPGDailyBetPromoUIAsync() {
      let result = await queryPGDailyBetPromoUI();
      if (result.Result) this.betUi = result.Result;
    },
    async queryPGLuckyOrderPromoUI_VAsync() {
      let result = await queryPGLuckyOrderPromoUI_V();
      if (result.Result) this.luckyOrderUi = result.Result;
    },
    async queryPGTaskLevelPromoUI_VAsync() {
      let result = await queryPGTaskLevelPromoUI_V();
      if (result.Result) this.taskLevelUi = result.Result;
    },
    async queryPGHighOddsOrdersPromoUI_VAsync() {
      let result = await queryPGHighOddsOrdersPromoUI_V();
      if (result.Result) this.highOddsOrdersUi = result.Result;
    },
    async initMessageData() {
      if (!this.isLoggedIn) {
        this.messageCount = 0;
        this.siteMessage.list = [];
        return;
      }
      await this.qeuryMessageCountAsync();
      await this.querySiteChatAsync();
    },
    async qeuryMessageCountAsync() {
      let result = await qeuryMessageCount();
      if (!result.Message) {
        this.messageCount = result.Result || 0;
      } else {
        this.messageCount = 0;
      }
    },
    switchNoticeTab(index) {
      this.currentIndexNotice = index;
      if (index === 0 && this.noticeMessage.list.length === 0) {
        this.queryNoticeAsync();
      }
      if (index === 1 && this.isLoggedIn) {
        this.qeuryMessageCountAsync();
        if (this.siteMessage.list.length === 0) {
          this.querySiteChatAsync();
        }
      }
    },
    openNoticeAll() {
      const parent = this.$parent;
      if (!this.isLoggedIn) {
        parent.loginShow = true;
        return;
      }
      parent.noticeShow = true;
      parent.currentIndexNotice = this.currentIndexNotice;
      if (this.currentIndexNotice === 0) {
        parent.queryNoticePageAsync(1);
      } else {
        parent.querySiteChatAsync(1);
      }
    },
    async queryNoticeAsync() {
      let result = await queryNotice();
      if (!result.Message) {
        this.noticeMessage.list = (result.Result.notices || []).slice(0, 3);
      }
    },
    async querySiteChatAsync() {
      let result = await querySiteChat(1);
      if (!result.Message) {
        this.siteMessage.list = (result.Result.modelList || []).slice(0, 3);
      }
    },
    async initAppDownload() {
      const parent = this.$parent;
      if (parent.appData && parent.appData.quanzhan_android) {
        this.appData = parent.appData;
      } else {
        let result = await queryAppData();
        if (!result.Message) {
          this.appData = result.Result;
          if (parent.appData !== undefined) {
            parent.appData = result.Result;
          }
        }
      }
      this.$nextTick(() => {
        this.switchAppQr(this.appPlatform);
      });
    },
    getAppDownloadUrl(platform) {
      const key = platform === 'ios' ? 'quanzhan_ios' : 'quanzhan_android';
      const item = this.appData[key];
      return item && item.apps ? item.apps : '';
    },
    switchAppQr(platform) {
      this.appPlatform = platform;
      const url = this.getAppDownloadUrl(platform);
      if (!url) return;
      this.$nextTick(() => {
        const el = document.getElementById('promo_qrcode');
        if (!el) return;
        el.innerHTML = '';
        this.promoQrcode = new QRCode('promo_qrcode', {
          text: url,
          width: 84,
          height: 84
        });
      });
    }
  }
};
</script>

<style scoped>
.promotion {
  display: flex;
  gap: 0.24rem;
  max-width: 100%;
  box-sizing: border-box;
  margin-top: 0.08rem;
}

.promotion .left {
  width: 13.86rem;
  max-width: 13.86rem;
  min-width: 0;
  box-sizing: border-box;
  overflow: hidden;
}

.promotion .right {
  width: 4.1rem;
  max-width: 4.1rem;
  display: flex;
  flex-direction: column;
  gap: 0.16rem;
  box-sizing: border-box;
}

.promotion .left > ul {
  display: flex;
  align-items: center;
  gap: 0.24rem;
}

.promotion .left > ul li {
  width: 1.28rem;
  height: 0.56rem;
  line-height: 0.56rem;
  text-align: center;
  border-radius: 0.08rem;
  cursor: pointer;
  font-size: 0.2rem;
  background: #282828;
}

.promotion .left > ul li.on {
  background: linear-gradient(180deg, #FF00A7 0%, #8800FF 100%);
  border-radius: 0.08rem;
  font-weight: bold;
}

.promotion dl {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 0.16rem;
  margin-top: 0.24rem;
}

.promotion dl dd {
  width: 4.36rem;
  height: 2.74rem;
  border-radius: 0.16rem;
  overflow: hidden;
  background: #202020;
  cursor: pointer;
  transition: all 0.3s ease;
}

.promotion dl dd:hover {
  transform: scale(1.03);
}

.promotion dl dd img {
  width: 4.36rem;
  height: 1.88rem;
}

.promotion dl dd div {
  padding: 0.16rem;
  display: flex;
  flex-direction: column;
  gap: 0.04rem;
}

.promotion dl dd div p {
  font-size: 0.2rem;
  font-weight: 600;
}

.promotion dl dd span {
  color: #999;
}

/* PG 大礼包：铺满 left 区域，PCBG 顶图 + 下方内容（同原 PGPromo 结构） */
.pg-detail {
  width: 100%;
  max-width: 100%;
  margin-top: 0.24rem;
  box-sizing: border-box;
  padding: 3.6rem 0.24rem 0.24rem;
  border-radius: 0.16rem;
  overflow: hidden;
  background-color: #000E2C;
  background-image: url('~@/img/PCBG.png');
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 100% auto;
}

.pg-detail .pg-content {
  width: 100%;
  height: 0.32rem;
  background: url('~@/img/p_content.png') no-repeat center center;
  background-size: contain;
}

.pg-detail .pg-intro {
  width: 100%;
  text-align: center;
  margin-top: 0.12rem;
  font-size: 0.16rem;
  color: #fff;
  line-height: 1.5;
}

.pg-detail .pg-option {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.24rem;
}

.pg-detail .pg-option ul {
  display: flex;
  align-items: center;
  height: 0.58rem;
  background: #030358;
  border-radius: 0.2rem;
}

.pg-detail .pg-option ul li {
  width: 1.4rem;
  height: 0.5rem;
  line-height: 0.5rem;
  text-align: center;
  cursor: pointer;
  font-size: 0.2rem;
  color: #FFFFFFCC;
  font-weight: bolder;
  background: transparent;
}

.pg-detail .pg-option ul li.on {
  background: linear-gradient(-144.66deg, #28A9FF 0%, #0062FF 100%);
  border-radius: 0.16rem;
}

.pg-detail .pg-option > div {
  width: 1.44rem;
  height: 0.6rem;
  background: #030358;
  border-radius: 0.08rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 0.2rem;
  font-weight: bolder;
  color: #fff;
}

.pg-detail .pg-option > div::before {
  content: '';
  display: block;
  width: 0.24rem;
  height: 0.24rem;
  background: url('~@/img/reco.png') no-repeat center center;
  background-size: contain;
  margin-right: 0.08rem;
}

.pg-detail .pg-record {
  margin: 0.24rem 0;
}

.pg-detail .pg-record ul {
  display: flex;
  gap: 0.24rem;
  flex-wrap: wrap;
}

.pg-detail .pg-record ul li {
  width: calc((100% - 0.48rem) / 3);
  height: 2.27rem;
  border-radius: 0.16rem;
  box-sizing: border-box;
}

.pg-detail .pg-record ul li .top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.pg-detail .pg-record ul li .top p {
  min-width: 0.82rem;
  max-width: 2.2rem;
  height: 0.4rem;
  line-height: 0.4rem;
  text-align: center;
  font-weight: bold;
  font-size: 0.12rem;
  border-radius: 0.16rem 0 0.16rem 0;
  background: #FF00008C;
  padding: 0 0.08rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pg-detail .pg-record ul li .top span {
  width: 0.83rem;
  height: 0.24rem;
  line-height: 0.24rem;
  text-align: center;
  font-size: 0.12rem;
  font-weight: bold;
  color: #fff;
  background: #00000033;
  border-radius: 0.12rem;
  cursor: pointer;
  margin-right: 0.08rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.pg-detail .pg-record ul li .top span::after {
  content: '';
  display: block;
  width: 0.16rem;
  height: 0.16rem;
  background: url('~@/img/info1.png') no-repeat center center;
  background-size: contain;
  margin-left: 0.04rem;
}

.pg-detail .pg-record ul li .info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #FFFFFF19;
  padding: 0 0.08rem;
}

.pg-detail .pg-record ul li .info div p:first-child {
  font-size: 0.18rem;
  font-weight: bolder;
  line-height: 0.3rem;
}

.pg-detail .pg-record ul li .info div p:last-child {
  font-size: 0.14rem;
  font-weight: bolder;
  color: #FAE42C;
}

.pg-detail .pg-record ul li .info > span {
  font-size: 0.48rem;
  font-weight: bold;
  color: #FAE42C;
  flex-shrink: 0;
}

.pg-detail .pg-record ul li .desc {
  margin-top: 0.08rem;
  padding: 0 0.08rem;
}

.pg-detail .pg-record ul li .desc p {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.14rem;
  margin-bottom: 0.08rem;
}

.pg-detail .pg-record ul li .desc p span:first-child {
  color: #FFFFFFB2;
}

.pg-detail .pg-record ul li .desc p span:last-child {
  color: #FFF;
}

.pg-detail .pg-record ul li .btn {
  width: calc(100% - 0.16rem);
  height: 0.48rem;
  line-height: 0.48rem;
  text-align: center;
  font-size: 0.2rem;
  font-weight: bolder;
  color: #B6471B;
  border-radius: 0.12rem;
  cursor: pointer;
  margin: 0.16rem auto 0;
}

.pg-detail .pg-rules {
  margin: 0.24rem 0 0;
}

.pg-detail .pg-rules > p {
  width: 100%;
  height: 0.32rem;
  background: url('~@/img/p_rules.png') no-repeat center center;
  background-size: contain;
}

.pg-detail .pg-rules > div {
  font-size: 0.14rem;
  color: #FFFFFFE5;
  margin-top: 0.16rem;
  line-height: 0.24rem;
}

/* 普通优惠详情：底框 886px = 8.86rem，居中，内容宽与 banner 一致 */
.promo-detail {

  max-width: 100%;
  margin-top: 0.24rem;
  background: #202020;
  border-radius: 0.16rem;
  overflow: hidden;
  box-sizing: border-box;
  padding: 0 2.27rem;
  padding-top: 0.32rem;
}

.promo-detail .detail-banner {
  width: 8.86rem;
  max-width: 100%;
  height: 3.86rem;
  overflow: hidden;
  flex-shrink: 0;
  border-radius: 0.16rem;
}

.promo-detail .detail-banner img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.promo-detail .detail-body {
  width: 100%;
  box-sizing: border-box;
  padding: 0.24rem;
}

.promo-detail .detail-title {
  margin: 0;
  font-size: 0.28rem;
  font-weight: bold;
  color: #fff;
  line-height: 1.4;
}

.promo-detail .detail-time {
  margin: 0.12rem 0 0;
  font-size: 0.16rem;
  color: #999;
}

.promo-detail .detail-table-block {
  margin-top: 0.24rem;
}

.promo-detail .table-title {
  margin: 0 0 0.12rem;
  font-size: 0.16rem;
  color: #ccc;
  line-height: 1.5;
}

.promo-detail .table-wrap {
  width: 100%;
  border-radius: 0.12rem;
  overflow: hidden;
}

.promo-detail .table-wrap table {
  width: 100%;
  border-collapse: collapse;
}

.promo-detail .table-wrap th,
.promo-detail .table-wrap td {
  padding: 0.14rem 0.08rem;
  text-align: center;
  font-size: 0.14rem;
  border: 1px solid #333;
}

.promo-detail .table-wrap th {
  background: #282828;
  color: #999;
  font-weight: 500;
}

.promo-detail .table-wrap td {
  background: #1e1e1e;
  color: #fff;
}

.promo-detail .detail-section {
  margin-top: 0.32rem;
}

.promo-detail .detail-section h3 {
  margin: 0 0 0.12rem;
  font-size: 0.2rem;
  font-weight: bold;
  color: #fff;
}

.promo-detail .detail-section p {
  margin: 0 0 0.08rem;
  font-size: 0.16rem;
  color: #999;
  line-height: 1.6;
}

/* 右侧栏 */
.promotion .right .msg-tabs {
  display: flex;
  gap: 0.08rem;
}

.promotion .right .msg-tabs li {
  flex: 1;
  height: 0.56rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.08rem;
  background: transparent;
  border: 1px solid #282828;
  border-radius: 0.08rem;
  font-size: 0.2rem;
  color: #999;
  cursor: pointer;
  position: relative;
  padding: 0 0.12rem;
  box-sizing: border-box;
}

.promotion .right .msg-tabs li .tab-icon {
  width: 0.2rem;
  height: 0.2rem;
  flex-shrink: 0;
}

.promotion .right .msg-tabs li.on {
  background: #282828;
  border-color: #282828;
  color: #fff;
  font-weight: 600;
}

.promotion .right .msg-tabs li.tab-site.has-unread {
  background: #600068;
  border-color: transparent;
  color: #fff;
}

.promotion .right .msg-tabs li.tab-site.has-unread::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 0.08rem;
  padding: 1px;
  background: linear-gradient(180deg, #FF00A7 0%, #8800FF 100%);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
}

.promotion .right .msg-tabs li.tab-site .tab-tag {
  position: absolute;
  right: 0.12rem;
  top: 50%;
  transform: translateY(-50%);
  padding: 0 0.08rem;
  height: 0.19rem;
  line-height: 0.19rem;
  font-size: 0.1rem;
  font-weight: bold;
  background: #FFFFFF19;
  border-radius: 0.48rem;
  white-space: nowrap;
  box-sizing: border-box;
}

.promotion .right .msg-tabs li.tab-site .tab-tag.unread {
  background: #FC5415;
  border-color: #FC5415;
  color: #fff;
  font-size: 0.11rem;
  font-weight: 600;
  min-width: 0.24rem;
  text-align: center;
  padding: 0 0.06rem;
}

.promotion .right .msg-list {
  display: flex;
  flex-direction: column;
  gap: 0.16rem;
}

.promotion .right .msg-item {
  flex-shrink: 0;
  height: 1.68rem;
  background: #282828;
  border-radius: 0.16rem;
  padding: 0.16rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
}

.promotion .right .msg-item .title {
  font-size: 0.16rem;
  color: #fff;
  font-weight: 600;
  margin: 0;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.promotion .right .msg-item .content {
  flex: 1;
  min-height: 0;
  font-size: 0.16rem;
  color: #999;
  line-height: 1.5;
  word-break: break-all;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  padding-top: 0.08rem;
}

.promotion .right .msg-item .time {
  font-size: 0.14rem;
  color: #ffffff33;
  flex-shrink: 0;
}

.promotion .right .msg-empty {
  height: 1.68rem;
  background: #282828;
  border-radius: 0.16rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.promotion .right .msg-empty img {
  width: 0.56rem;
  height: 0.56rem;
}

.promotion .right .msg-empty span {
  font-size: 0.14rem;
  color: #999;
  margin-top: 0.04rem;
}

.promotion .right .msg-foot {
  height: 0.48rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #282828;
  border-radius: 0.16rem;
  font-size: 0.14rem;
  color: #999;
  cursor: pointer;
  gap: 0.04rem;
}

.promotion .right .msg-foot span:first-child {
  color: #fff;
}

.promotion .right .msg-foot .arrow {
  width: 0.16rem;
  height: 0.16rem;
  background: url("@/img/right.png") no-repeat center center;
  background-size: contain;
  margin-left: 0.04rem;
}

.promotion .right .app-dl {
  width: 100%;
  height: 2.44rem;
  border-radius: 0.16rem;
  background: url("@/img/appdl.png") no-repeat left center;
  background-size: cover;
  position: relative;
  overflow: hidden;
}

.promotion .right .app-dl .qr-side {
  position: absolute;
  right: 0.24rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.08rem;
}

.promotion .right .app-dl .qr-box {
  width: 1.08rem;
  height: 1.08rem;
  background: #fff;
  border-radius: 0.08rem;
  padding: 0.06rem;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.promotion .right .app-dl .qr-box >>> img,
.promotion .right .app-dl .qr-box >>> canvas {
  width: 100% !important;
  height: 100% !important;
}

.promotion .right .app-dl .qr-side p {
  margin: 0;
  font-size: 0.16rem;
  color: #fff;
  font-weight: 600;
  white-space: nowrap;
}

.promotion .right .app-dl .app-btns {
  display: flex;
  gap: 0.08rem;
  margin-top: 0.04rem;
}

.promotion .right .app-dl .app-btns span {
  min-width: 0.48rem;
  height: 0.28rem;
  padding: 0 0.08rem;
  border-radius: 0.08rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.08);
  font-size: 0.12rem;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-sizing: border-box;
  white-space: nowrap;
}

.promotion .right .app-dl .app-btns span.on {
  border-color: transparent;
  background: linear-gradient(180deg, #FF00A7 0%, #8800FF 100%);
  font-weight: bold;
}
</style>
